import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to the top of the page on route changes.
 *
 * Uses `useLocation` from `react-router-dom` to listen for route changes and
 * scrolls to the top using `window.scrollTo(0, 0)`.
 *
 */
const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
};

export default useScrollToTop;
